import { useEffect, useRef, type ReactElement } from "react";
import ReactGA from "react-ga";
import { Route, Switch } from "wouter";
import { routes } from "./stores/routes";
import { NavMenu, FourOhFour } from "./sections";
import { Modalize, RegionShield } from "@components";
import { Messenger } from "@bracket/react-messenger";
import { bindSafaryToContext } from "@bracket/safary";
import { useAccount } from "wagmi";

import "./App.scss";
import { ConnectionManager } from "./components/ConnectionManager/ConnectionManager";

export const App = (): ReactElement => {
  useEffect(() => {
    console.log("version 37");
  }, []);
  const { address } = useAccount();

  const classes = () => ["stake-app"].filter((v) => v).join(" ");
  const appRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ReactGA.initialize("G-10K1M7P99V");
    bindSafaryToContext();
  }, []);

  useEffect(() => {
    if ((window as any)?.MetaCRMWidget?.manualConnectWallet) {
      (window as any).MetaCRMWidget.manualConnectWallet(address);
    }

    const handleConnectWidget = () => {
      (window as any).MetaCRMWidget.manualConnectWallet(address);
    };
    document.addEventListener("MetaCRMLoaded", handleConnectWidget);

    return () => {
      document.removeEventListener("MetaCRMLoaded", handleConnectWidget);
    };
  }, [address]);

  return (
    <div id="stake-app" ref={appRef} className={classes()}>
      <RegionShield>
        <ConnectionManager>
          <NavMenu />
          <Messenger />
          <section className="main">
            <Switch>
              {routes
                .filter((r) => !r?.isExternal && !r?.disabled)
                .map((route, i) => (
                  <Route
                    key={`route${i}`}
                    path={route.route}
                    component={route.component}
                  />
                ))}
              <Route>
                <FourOhFour />
              </Route>
            </Switch>
          </section>
        </ConnectionManager>
      </RegionShield>
      <Modalize />
    </div>
  );
};
